<template>
  <div class="mk-stepper">
    <div
      v-for="(step, index) in steps"
      :key="`step-${index}`"
      class="mk-stepper__step"
    >
      <div
        class="mk-stepper__step__container"
        :class="stepActive > index  ? 'mk-stepper__step__container--done' : ''"
        @click="stepClicked(index)"
      >
        <div
          class="mk-stepper__step__number"
          :class="
            (stepActive === index  ? 'mk-stepper__step__number--active' : '')
            + (stepActive > index  ? 'mk-stepper__step__number--done' : '')
          "
        >
          <span v-if="index >= stepActive">{{index + 1}} </span>
          <CheckBold v-else/>
        </div>
        <span class="mk-stepper__step__text">
          {{step}}
        </span>
      </div>
      <div
        class="mk-stepper__step__spacer"
        v-if="steps.length - 1 > index"
      />
    </div>
    <div
      class="mk-stepper__step__mobile"
    >
      <button
        class="mk-stepper__step__mobile__back"
        @click="stepClicked(stepActive - 1)"
        v-if="stepActive !== 0"
      >
        <ArrowLeft />
      </button>
      <div
        class="mk-stepper__step__mobile__part"
      >
        {{`${stepActive + 1}/${steps.length}`}}
      </div>
      <span class="mk-stepper__step__text">
        {{steps[stepActive]}}
      </span>
    </div>
  </div>
</template>

<script>
/**
 * Stepper
 * @author David <david.prenninger@gmx.de>
 *
 * This component is used as header of the application showing the current
 * configuration progress.
 * The user can click on past steps to go back.
 */
import ArrowLeft from 'vue-material-design-icons/ArrowLeft.vue';
import CheckBold from 'vue-material-design-icons/CheckBold.vue';

export default {
  components: {
    ArrowLeft,
    CheckBold,
  },
  data() {
    return {
      steps: [
        this.$t('stepper.counterStyle'),
        this.$t('stepper.dimensions'),
        this.$t('stepper.glasses'),
        this.$t('stepper.checkout'),
      ],
    };
  },
  computed: {
    stepActive() {
      return this.$store.getters.stepActive;
    },
  },
  methods: {
    stepClicked(index) {
      this.$store.dispatch('goToStep', index);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/defaults.scss";

.mk-stepper {
  display: flex;
  align-items: center;
  box-shadow: $bs_md;
  padding: 10px;
  justify-content: space-between;
  position: absolute;
  z-index: 10;
  width: 100%;
  box-sizing: border-box;

  &__step {
    display: flex;
    align-items: center;
    flex-grow: 1;

    @media (max-width: 700px) {
       display: none;
    }

    &__mobile {
      display: none;

      @media (max-width: 700px) {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-grow: 1;
      }

      &__back {
        position: absolute;
        left: 8px;
        top: 9px;
        font-size: 20px;
        border: none;
        background-color: transparent;
      }

      &__part {
        color: $c_accent;
      }
    }

    &__container {
      display: flex;
      align-items: center;

      &--done {
        cursor: pointer;
      }
    }

    &__number {
      background-color: $c_grey;
      color: $c_white;
      width: 25px;
      height: 25px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 10px;

      &--active {
        background-color: $c_accent;
      }

      &--done {
        background-color: $c_green;
      }
    }

    &__spacer {
      flex-grow: 1;
      border-bottom: 1px solid $c_grey;
      margin-left: 10px;
    }

    &__text {
      margin-left: 10px;
    }
  }
}
</style>
